export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:error', (error) => {
    if (error instanceof TypeError && error.message?.includes('dynamically imported module')) {
      if (true && typeof window !== 'undefined') {
        window.location.reload()
      }
    }
  })
})